import { convertToLocalStyle } from './utils/convert-style';
import { scrollbarStyle } from './shared-styles-from-theme-fluent';

export const adsExtensionDoubleListStyle = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({

  '& .associations__container': {
    padding: '0 14px',
    margin: '0 15px',
    width: 750,
    ...convertToLocalStyle(scrollbarStyle({ palette })),

    '& .panel': {
      boxShadow: 'none',
    },

    '& .panel-body': {
      padding: '0',

      '& h5': {
        fontSize: 14,
        fontWeight: 'normal',
        margin: '0 0 10px 0',
      },
    },

    '& .extension-editor-dblist-container, .alert-danger': {
      marginLeft: 2,
    },

    '& #editorErrors': {
      paddingLeft: '8px',
    },

    '& .doubleListBox': {

      '& .layout-columns-container ': {

        minHeight: 261,

        '& .layout-columns-element[data-bind="visible: features.filtering || showMaximumSelectionAlert"]': {
          display: 'flex',
          flexDirection: 'column',

          '& .form-group[data-bind="visible: features.filtering"]': {
            order: 2,
          },

          '& >div[data-bind="visible: showMaximumSelectionAlert"]': {
            order: 1,
            marginBottom: 10.5,
          },
        },

        '& .dlb-filter-alignPlaceholder': {
          paddingBottom: 5,
          paddingLeft: 15,
          position: 'absolute',

          '& .searchbox': {
            width: 300,

            '& .form-control': {
              border: `1px solid ${palette.neutralSecondary}`,
              borderBottom: 0,
              height: 48,
            },

            '& .form-control-feedback': {
              position: 'absolute',
              left: 0,
              lineHeight: '46px',
              pointerEvents: 'auto',
            },
          },
        },


        '& .layout-columns-element:nth-child(2)': {
          width: 300,
          height: 'auto',
          marginRight: 8,
          marginTop: 45,
          padding: 0,


          '& .row.form-group': {
            overflowY: 'auto',
            height: 316,
            border: `1px solid ${palette.neutralSecondary}`,
          },
        },

        '& .layout-columns-element:nth-child(3)': {
          width: 300,
          border: `1px solid ${palette.neutralSecondary}`,
          marginRight: 8,
          padding: 0,
          height: 361,

          '& .panel-body': {
            height: 213,
            overflowY: 'auto',
          },
        },

        '& .panel-heading': {
          padding: 0,

          '& .panel-title': {
            fontSize: 14,
            height: 'auto',
            lineHeight: '36px',
            padding: '0 8px',
          },
        },

        '& .col-sm-12': {
          padding: 0,
        },
      },

      '& .dlbItem, & .dlb-source-header, & .dlb-selected-header, & .k-loading-mask': {
        padding: '0 8px',
      },

      '& .dlbItem:hover': {
        background: '#EDEBE9',
      },

      '& .dlbItem-content': {
        minHeight: 36,
        lineHeight: '36px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',

        '& .wordwrap, .itemTemplate-text, .appListItem-text': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },

        '& .type-bold': {
          fontWeight: 600,
        },
      },

      '& .dlbItem-actions': {
        float: 'right',
        marginTop: 8,
      },

      '& .arrow-button.enabled': {
        marginLeft: 10,
        overflow: 'visible !important',
        textDecoration: 'none !important',
        background: 'none !important',
        fontFamily: iconFontFamily,
        cursor: 'pointer',
      },

      '& .arrow-button.enabled:before': {
        content: '"\\E710"',
      },

      '& .arrow-button.remove': {
        marginRight: 10,
        float: 'right',
        fontFamily: iconFontFamily,
        padding: 0,
        marginTop: 8,
      },

      '& .arrow-button.remove:before': {
        content: '"\\E738"',
      },

      '& .arrow-button.remove+a': {
        width: 'fit-content',
        padding: 0,
      },

      '& .itemTemplate-text': {
        '& li': {
          height: 32,
          lineHeight: '32px',

          '& a': {
            verticalAlign: 'middle',
          },
        },
      },


      '& .pager': {
        height: 'auto',

        '& .pager-page': {
          float: 'right',

          '& span': {
            marginLeft: 6,
            verticalAlign: 'baseline',
          },
        },
      },
    },

    '& .create-link-Container': {
      marginLeft: 2,
      marginTop: 10,

      '& span': {
        verticalAlign: 'top',
        color: palette.themePrimary,
      },

      '& a.btn-create': {
        position: 'relative',
        left: -21,
        paddingLeft: 21,
        paddingRight: 8,
      },
    },

    '& .save-bar': {
      margin: '10px 0 20px 0',
    },

    '& .create-extension': {
      padding: '8px',
      position: 'relative',
      left: '-8px',

      '& .glyphicon-plus': {
        marginRight: 12,
        verticalAlign: 'inherit',
      },
    },

    '& .campaign-adextension-list': {
      width: 400,

      '& .adExtension-previewbox div': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
    },

  },

  '& div[data-type="StructuredSnippet"]': {
    '& .doubleListBox': {
      '& .layout-columns-container ': {
        '& .dlb-filter-alignPlaceholder': {
          '& .searchbox': {
            width: 346,
          },
        },

        '& .layout-columns-element:nth-child(2)': {
          width: 346,
        },

        '& .layout-columns-element:nth-child(3)': {
          width: 346,
        },
      },
    },
  },
});
